import styled from 'styled-components';

export const Wrapper = styled.div`
  .deliveryAddressInput,
  .aptSuiteInput {
    margin-bottom: 0.5em;
  }
`;
